import React from 'react';
import PageAncestor from 'core/common/page/pageAncestor';
import gridService from 'core/grid/gridService';
import GridCompConnected from 'core/grid/component/gridCompConnected';
import {ZzFlatButtonRoute} from "core/components/buttons/buttons";
import {MODULE, PERMISSION, PageProps} from "core/metamodel/metaConstant";
import {PAGE} from "routes";
import {observer} from "mobx-react";
import mdEntityService from "core/metamodel/mdEntityService";
import {loc} from "core/common/config/locales";

const gridLocation = 'userList';

@observer
export default class UserList extends PageAncestor<PageProps, undefined> {

  static module = MODULE.core;
  static title = loc.i18n`Users`;
  static icon = 'user';
  static rootPage = true;
  static protectedPage = true;


  static fetchData(routerParams) {
    console.log("UserList#fetchData(%s)", gridLocation);
    return gridService.fetchGrids(gridLocation)
      .then(gl => gridService.getOrCreateGrid(gridLocation));
  }


  render() {
    let {params, query} = this.props;

    return (
        <GridCompConnected grid={gridService.getOrCreateGrid(gridLocation)} entities={mdEntityService.entityMap} gridId={params.gridId} query={query}>
          <ZzFlatButtonRoute onGridToolbar routeName="userDetail" params={{id: 'new'}} label="New User" permission={PERMISSION.New} securable={PAGE.userDetail}/>
        </GridCompConnected>
    );
  }


}



// WEBPACK FOOTER //
// ./src/core/security/userList.tsx